module.exports = __webpack_public_path__ + "static/media/Logo_Ideer(white).191fcd40.png";